import React, {useEffect, useState} from 'react'
import {Layout} from "../components";
import styles from "../styles/About.module.scss"
import send from "../icons/send.svg"
import pioneer from "../icons/pioneer_enterprise.svg"
import quality from "../icons/quality_promise.svg"
import vision from "../icons/vision.svg"
import linkedIn from "../icons/linkenin.svg"
import {doc, getFirestore, setDoc} from "firebase/firestore";
import abhay from "../images/_DSC4827.JPG"


const About = () => {

    const [user, setUser] = useState({});
    const [message, setMessage] = useState(null);
    const [notification, setNotification] = useState(null);
    const [className, setClassName] = useState(`${styles.alert} ${styles.info}`);

// Initialize Firebase

    const db = getFirestore();
    const pushRecords = async (e) => {
        e.preventDefault();
        try {
            const eventRef = doc(db, `events`, user.email);
            setDoc(eventRef, {...user, type: 'demo'}, {merge: true})
            setClassName(`${styles.alert} ${styles.success}`);
            setMessage("Thanks for sharing your interest, our team will reach out to you shortly");
            setNotification({
                email: user.email,
                type: 'demo'
            })

        } catch (e) {
            setClassName(`${styles.alert} ${styles.warning}`);
            setMessage("We are facing issues in processing your request. Please drop a note to us at " +
                "support@cosmoneural.com")
            //console.error("Error adding document: ", e);
        }
    }

    useEffect(() => {
        window.scrollTo(0, 0);
        if (message) {
            setTimeout(() => {
                setMessage(null);
            }, 3000);

        }
    }, [message]);

    return (<Layout classes={styles.body} notification={notification}>
        {message && <div className={styles.recoveryMessageOverlay}>
            <div className={className}>
                <span className={styles.closebtn}>&times;</span>
                {message}
            </div>
        </div>}
        <section className={styles.banner}>
            <div className={styles.bannerContainer}>
                <div className={styles.bannerInner}>
                    <div className={styles.bannerItem1}>
                        <h1>
                            We provide support for each
                            stage of your business.</h1>
                    </div>
                    <div className={styles.bannerItem2}>
                        <ol>
                            <li>
                                <h6>
                                    Research</h6>
                                <p>
                                    Enabling product Research and Development
                                </p>
                            </li>
                            <li>
                                <h6>
                                    Strategise</h6>
                                <p>
                                    Our expert EA team helps you in Strategising your business model with outcomes
                                </p>
                            </li>
                            <li>
                                <h6>
                                    Design</h6>
                                <p>
                                    Designing with UX and backed by powerful EA.
                                </p>
                            </li>
                            <li>
                                <h6> Develop</h6>
                                <p>Building your product or solution to the highest standard</p>
                            </li>
                            <li>
                                <h6> Launch</h6>
                                <p>Launching your product into success</p>
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
        </section>

        {/* <div className={styles.companiesContainer}>
            <div className={styles.companiesSubContainer}>
                <h4>Trusted By Leading Companies</h4>
                <div className={styles.companyList}>
                    {companies.map((company, index) => (
                        <div>
                            <img src={company.logo} alt={company.id}/>
                        </div>
                    ))}
                </div>
            </div>
        </div>*/}

        <section style={{
            backgroundColor: "#FFFFFF",
            display: 'flex',
            flexDirection: "column",
            width: '100%',
            padding: '10px'
        }}>
            <section style={{
                width: '100%',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: "center",
                alignItems: "center"
            }}>
                <h3>About</h3>
                <div className={styles.cardListing}>
                    <div className={styles.card}>
                        <div className={styles.details}>
                            <img src={pioneer} alt='pioneer'/>
                            <div>
                                <h6>Pioneering Enterprise Solutions</h6>
                                <p>Cosmoneural develops and offers a broad range of products that enable domains to tap into the potential of technology to solve real-world problems. Our consulting services help enterprises perform efficiently and compete successfully by incorporating future-proofed solutions. We are the preferred technology partner of reputed companies from around the globe.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className={styles.card}>
                        <div className={styles.details}>
                            <img src={vision} alt='vision'/>
                            <div>
                                <h6>Our Vision</h6>
                                <p>To deliver outstanding technology solutions that help businesses script their success
                                    story and facilitate the empowerment of the socioeconomically disadvantaged
                                    communities. </p>
                            </div>
                        </div>
                    </div>
                    <div className={styles.card}>
                        <div className={styles.details}>
                            <img src={quality} alt='quality'/>
                            <div>
                                <h6>Our Quality Promise</h6>
                                <p>At Cosmoneural, we focus on the prerequisites to consistently deliver excellent
                                    quality technology solutions.
                                    <br/><br/>
                                    Security & Privacy | Transparency | Innovation | Scalability | Easy Accessibility
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <h3 style={{marginTop: '40px'}}>
                    Meet our Founder
                </h3>
                <div className={styles.goals}>
                    <div className={`${styles.goalsInner} ${styles.reverse}`}>
                        <div className={styles.goalsItem1}>
                            <img style={{width:'auto', height:'auto', maxWidth:'unset'}} src={abhay} alt='abhay'/>
                        </div>
                        <div className={styles.goalsItem2}>
                            <div className={styles.content} style={{alignItems: 'flex-start'}}>
                               {/* <h6>CEO</h6>*/}
                                <h5>Abhay Phougat</h5>
                                <p style={{textAlign: 'start'}}>Abhay is a seasoned tech leader who has worked with some of the world's top
                                    brands, helping them design, architect, and build solution that deliver value to
                                    their clients. The experience he gained from working at Infosys, Accenture, SAP and
                                    Tata Digital, among others, inspired him to establish a company that develops and
                                    provides superior quality products to a wide variety of users. With
                                    Cosmoneural's
                                    consulting services, his objective is to provide businesses with a blueprint for
                                    constructing a robust, agile, and flexible enterprise architecture designed to help
                                    them meet their organisational needs. In addition, he is also collaborating with the
                                    public and social sectors to build innovative solutions that accelerate the upward
                                    mobility of the society.
                                </p>
                                <a href='https://www.linkedin.com/in/phougat/'><img src={linkedIn} alt='linkedin'/></a>
                                <div style={{display: 'flex', justifyContent: 'center', marginTop: '20px'}}>
                                    <button onClick={() => window.location.href= 'contactus' }>Lets Speak
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </section>

            <div className={styles.demo}>
                <div className={styles.sendContainer}>
                    <h5>We’d love to give you a demo</h5>
                    <form onSubmit={pushRecords} className={styles.send}><input required type='email' value={user.email}
                                                                                onChange={(e) => setUser({
                                                                                    ...user,
                                                                                    email: e.target.value
                                                                                })}
                                                                                placeholder='Type your email address in here'/>
                        <button type='submit'><img
                            src={send} alt={"send"}/></button>
                    </form>
                </div>
            </div>
        </section>

    </Layout>)
}

export default About;
